import React, { useState, useCallback } from "react";
import NotificationBadge from "../notificationBadge/NotificationBadge";
import NotificationModal from "../modals/notificationModal/NotificationModal";
import { useNotifications } from "../../hooks/useNotifications";
import "./NotificationPanel.css";


/**
 * NotificationPanel
 *
 * Always externally controlled — Header owns the open/close state.
 * This means one hook instance, one data source, shared between the
 * desktop bell click and the mobile drawer "Notifications" tap.
 *
 * Props:
 *   userId   {string}   — MongoDB _id of the logged-in user
 *   isOpen   {boolean}  — whether the panel is visible
 *   onClose  {fn}       — called when panel wants to close
 *   onToggle {fn}       — called when the bell icon is clicked
 */
const NotificationPanel = ({ userId, isOpen, onClose, onToggle }) => {
  const {
    notifications,
    displayed,
    unreadCount,
    newCount,
    activeTab,
    setActiveTab,
    loading,
    hasMore,
    loadMore,
    markAsRead,
    markAllAsRead,
    removeNotification,
  } = useNotifications(userId);

  if (!userId) return null;

  return (
    <div className="np-root">
      {/* Bell icon — always visible on all screen sizes */}
      <NotificationBadge
        count={unreadCount}
        isOpen={isOpen}
        onClick={onToggle}
      />

      {isOpen && (
        <NotificationModal
          notifications={notifications}
          displayed={displayed}
          unreadCount={unreadCount}
          newCount={newCount}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          loading={loading}
          hasMore={hasMore}
          loadMore={loadMore}
          markAsRead={markAsRead}
          markAllAsRead={markAllAsRead}
          removeNotification={removeNotification}
          onClose={onClose}
        />
      )}
    </div>
  );
};

export default NotificationPanel;
